export const environment = {
  production: true,
  apiUrl: 'https://testapi.udruga.eu'
};